import { SETTINGS_DEFAULT_SCREEN } from 'components/Settings/utils'
import { useHistory, useLocation } from 'react-router-dom'

export const useOpenSettings = () => {
  const history = useHistory()
  const location = useLocation()

  const openSettings = (screen = SETTINGS_DEFAULT_SCREEN) => {
    const queryParams = new URLSearchParams(location.search)
    queryParams.set('settings', screen)
    history.push({ search: queryParams.toString() })
  }

  return { openSettings }
}
